import { CSSProperties, FC } from 'react'

import { Avatar, clsx, rem, Skeleton } from '@mantine/core'

import { assetImagePath } from 'interfaces/constants'
import { DataAttributeKey } from 'interfaces/types'

import {
  StyledCardArticleAuthor,
  StyledCardArticleAuthorLabel,
  StyledCardArticleAuthorWrap,
} from './CardArticleAuthor.styled'

export type CardArticleAuthorItemTracking = Partial<
  Record<'authorAvatar', Record<DataAttributeKey, string | number>>
>
export type CardArticleAuthorItem = {
  permalink: string
  avatar: string | JSX.Element
  avatarAlt?: string
  name: string | JSX.Element | (string | JSX.Element)[]
  indicator: string | JSX.Element
}

export type CardArticleAuthorProps = {
  loading?: boolean
  author?: CardArticleAuthorItem
  authorTracking?: CardArticleAuthorItemTracking
  className?: string
  style?: CSSProperties
}

export const CardArticleAuthor: FC<CardArticleAuthorProps> = (props) => {
  const { loading, author, authorTracking, className, style } = props
  const {
    permalink,
    name,
    avatar: avatarProps,
    avatarAlt: avatarAltProps,
    // indicator: indicatorProps,
  } = author || {}

  const avatarAlt = typeof name === 'string' ? name : avatarAltProps || ''
  const avatar =
    typeof avatarProps === 'string' ? (
      <Avatar
        src={avatarProps}
        alt={avatarAlt}
        radius="50%"
        className="cardArticleAuthorAvatar"
      >
        {/* Custom Placeholder in the case avatar has failed to load */}
        <img
          loading="lazy"
          src={`${assetImagePath}/avatar.jpg`}
          alt=""
          style={{ borderRadius: '50%' }}
        />
      </Avatar>
    ) : (
      avatarProps
    )
  const cardArticleAuthorProps = permalink
    ? { ...authorTracking?.authorAvatar, href: permalink }
    : {}

  // const indicator =
  //   typeof indicatorProps === 'string' ? (
  //     <img
  //       loading="lazy"
  //       src={indicatorProps}
  //       alt=""
  //       className="cardArticleAuthorIndicatorIcon"
  //     />
  //   ) : (
  //     indicatorProps
  //   )

  if (loading) {
    return (
      <StyledCardArticleAuthor
        className={clsx('cardArticleAuthor', className)}
        style={style}
      >
        <StyledCardArticleAuthorWrap className="cardArticleAuthorAvatarWrap">
          <Skeleton width={rem(24)} height={rem(24)} radius="50%" />
        </StyledCardArticleAuthorWrap>
        <StyledCardArticleAuthorLabel className="cardArticleAuthorLabel">
          <Skeleton width="100%" height="1rem" />
        </StyledCardArticleAuthorLabel>
      </StyledCardArticleAuthor>
    )
  }

  if (!author) {
    return null
  }

  return (
    <StyledCardArticleAuthor
      className={clsx('cardArticleAuthor', className)}
      style={style}
    >
      <StyledCardArticleAuthorWrap
        as={permalink ? 'a' : 'div'}
        className="cardArticleAuthorAvatarWrap"
        {...cardArticleAuthorProps}
      >
        {/*
				https://hhgdev.atlassian.net/browse/HHD-6390
				<Indicator
          label={indicator}
          color="transparent"
          offset={4}
          position="bottom-end"
          styles={{ root: { zIndex: 1 }, indicator: { paddingInline: 0 } }}
          className="cardArticleAuthorIndicator"
        >
          {avatar}
        </Indicator> 
				*/}
        {avatar}
      </StyledCardArticleAuthorWrap>
      <StyledCardArticleAuthorLabel
        size="c1"
        className="cardArticleAuthorLabel"
      >
        {name}
      </StyledCardArticleAuthorLabel>
    </StyledCardArticleAuthor>
  )
}
